<template>
    <div>
        <div class="card-header">
            <div class="card-header-left">
                <h5>Application</h5>
                <br>
            </div>
        </div>
        <div class="card-block user-detail-card">
            <div class="row">
                <div class="col-sm-9 user-detail">
                    <div class="row" v-if="hasValue($parent.applicant.firstname)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>First Name:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.firstname}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.lastname)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>Last Name:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.lastname}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.age)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-calendar"></i>Age:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.age}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.gender)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>Gender:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.gender}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.phonenumber)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-touch-phone"></i>Phone:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.phonenumber}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.emailaddress)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-email"></i>Email:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30"><a v-bind:href="'mailto:' + $parent.applicant.emailaddress">{{$parent.applicant.emailaddress}}</a></h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.course)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-graduate-alt"></i>Course:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.course}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.education)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-hat"></i>Qualification:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.education}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.grades)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-certificate"></i>Grade:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.grades}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.current_location)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-location-pin"></i>Location:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.current_location}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.current_employer)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-businessman"></i>Current or Immediate
                                Past Employer:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.current_employer}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.years_of_experience)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-certificate"></i>Years of Experience</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.years_of_experience}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.linkedinprofile)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="ti ti-linkedin"></i>LinkedIn:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30"><a href="">{{$parent.applicant.linkedinprofile}}</a></h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.referrer)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Referrer:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.referrer}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasValue($parent.applicant.referrer_name)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Referrer Name:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.referrer_name}}</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Date Applied:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{$parent.applicant.created_at.split(" ")[0]}}</h6>
                        </div>
                    </div>
                    <div class="row" v-if="hasDocument('cv')">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Resume:</h6>
                        </div>
                        <div class="col-sm-7">
                            <span v-for="document in $parent.applicant.documents">
                                <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                    target="_blank" v-if="document.document_type == 'cv'">View</a>
                            </span>

                        </div>
                    </div>
                    <div class="row" v-if="hasDocument('nysc')">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>NYSC:</h6>
                        </div>
                        <div class="col-sm-7">
                            <span v-for="document in $parent.applicant.documents">
                                <a class="btn btn-primary btn-sm" v-bind:href="getFile(document.link)"
                                    target="_blank" v-if="document.document_type == 'nysc'">View</a>
                            </span>

                        </div>
                    </div>
                    <div class="row" v-if="hasDocument('waec')">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>WAEC Certificte:</h6>
                        </div>
                        <div class="col-sm-7">
                            <span v-for="document in $parent.applicant.documents">
                                <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                    target="_blank" v-if="document.document_type == 'waec'">View</a>
                            </span>

                        </div>
                    </div>
                    <div class="row" v-if="hasDocument('Undergraduate')">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Undergraduate
                                Degree Certificte:</h6>
                        </div>
                        <div class="col-sm-7">
                            <span v-for="document in $parent.applicant.documents">
                                <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                    target="_blank" v-if="document.document_type == 'Undergraduate'">View
                                </a>
                            </span>

                        </div>
                    </div>
                    <div class="row" v-if="hasDocument('other')">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>First School
                                Leaving Certificte:</h6>
                        </div>
                        <div class="col-sm-7">
                            <span v-for="document in $parent.applicant.documents">
                                <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                    target="_blank" v-if="document.document_type == 'other'">View</a>
                            </span>

                        </div>
                    </div>
                    <div class="row" v-if="hasDocument('passport')">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Candidate Passport:</h6>
                        </div>
                        <div class="col-sm-7">
                            <span v-for="document in $parent.applicant.documents">
                                <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                    target="_blank" v-if="document.document_type == 'passport'">View</a>
                            </span>

                        </div>
                    </div>

                    <div class="row" v-if="hasValue($parent.applicant.cover_letter)">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Cover Letter:</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30" v-html="$parent.applicant.cover_letter"></h6>
                        </div>
                    </div>

                    <h4 class="text-center mt-3">Job Listing Questions</h4>
                    <div class="row" v-for="question in $parent.applicant.interview_answers">
                        <div class="col-sm-5">
                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-question-circle"></i>{{question.question}}</h6>
                        </div>
                        <div class="col-sm-7">
                            <h6 class="m-b-30">{{question.answer}}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="image-holder">
                        <img src="assets/img/user-icon.jpg" alt="" class="p-b-10">
                    </div>
                    <div class="contact-icon" v-if="$parent.applicant.applicant_final_stage == undefined || $parent.applicant.applicant_final_stage.id < 2">
                        <p>
                            <b>Stage Actions</b>
                        </p>

                        <button v-if="$checkPerm('application.approve_to_stage_2')" class="btn btn-success btn-sm m-1"
                            data-toggle="modal" data-target="#nextStage">Approve for Stage 2</button>

                        <button class="btn btn-warning btn-sm m-1" data-toggle="modal" data-target="#star" v-if="$parent.applicant.is_starred == '0' && $checkPerm('application.archive')">Keep
                            In View</button>

                        <button class="btn btn-warning btn-sm m-1" data-toggle="modal" data-target="#star" v-if="$parent.applicant.is_starred == '1' && $checkPerm('application.unarchive')">Unarchive
                            Applicant</button>

                        <button v-if="$checkPerm('application.share_to_hiring_manager')" class="btn btn-info btn-sm m-1"
                            title="Share Resume" data-toggle="modal" v-on:click="listhiringmanager" data-target="#shareResume">Share
                            Resume</button>

                        <button v-if="$checkPerm('application.discontinue')" class="btn btn-danger btn-sm m-1"
                            v-on:click="$parent.deleteApplicant()">Discontinue Application</button>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="$checkPerm('application.approve_to_stage_2')" id="nextStage" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Approve {{$parent.applicant.firstname + " " +
                            $parent.applicant.lastname}} for next stage.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="approveApplicant">
                            <div class="form-group">
                                <label>Choose processes for applicant to undergo in next stage.</label>
                                <select class="form-control" v-model="approve_applicant.process_id">
                                    <option v-for="process in $parent.processes" v-bind:value="process.id">{{process.process_name}}</option>
                                </select>
                                <!-- <div v-for="process in processes">
                                    <input type="checkbox" v-model="stage_processes.process_id" name="processes" v-bind:value="process.id" />
                                    {{process.process_name}}
                                </div> -->
                                <a class="sub-text label label-primary label-sm mt-3" href="/stages" target="_blank">
                                    <i class="ti-plus"></i>
                                    Add Process
                                </a>
                            </div>
                            <div class="form-group" v-if="$parent.stage_processes.process_id.length < 3">
                                <button class="btn btn-md btn-success">Approve</button>
                            </div>
                            <div class="form-group" v-else>
                                <label class="label label-warning">Cannot approve user for more than 2 processes at
                                    once.</label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="$checkPerm('application.share_to_hiring_manager')" id="shareResume" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Share Resume</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="shareResume">
                            <div class="form-group">
                                <label>Email Subject:</label>
                                <input class="form-control" placeholder="Subject" maxlength="50" v-model="share_resume.subject"
                                    required="required" />
                            </div>
                            <div class="form-group">
                                <label>Select Hiring Manager:</label>
                                <select class="form-control" v-model="share_resume.id" required>
                                    <option v-for="hiringmanager in hiringmanagers" v-bind:value="hiringmanager.id">{{hiringmanager.email}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Email Title:</label>
                                <input class="form-control" placeholder="Title" v-model="share_resume.email_title"
                                    required="required" />
                            </div>
                            <div class="form-group">
                                <label>Email Body:</label>
                                <textarea class="form-control" placeholder="Email Body" v-model="share_resume.email_body"
                                    required="required"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>

</style>

<script type="text/javascript">
    export default {
        name: 'Stage1',
        data() {
            return {
                approve_applicant: {
                    applicant_id: this.$route.params.applicant_id,
                    process_id: ''
                },
                hiringmanagers: [],
                share_resume: {
                    subject: "Waje Smart Solutions Recruitment (New CV)",
                    recipient: "",
                    email_title: "",
                    email_body: "Kindly review attached document for further appraisal and possible hiring.",
                    applicant_ids: []
                },
            }
        },
        mounted() {

        },
        methods: {
            getFile(file) {
                return file.includes('https://') ? file : 'https://wajesmarthrms.website' + file;
            },
            hasValue(value) {
                return value !== null && value !== undefined && value !== '';
            },
            hasDocument(documentType) {
                return (this.$parent.applicant.documents || []).some((document) => document.document_type == documentType);
            },
            approveApplicant() {

                // this.stage_processes.applicant_id = applicant.id

                // data = this.stage_processes

                var approve = {
                    what: 'ApproveStage2',
                    data: this.approve_applicant
                }

                let c = confirm("Approve applicant for next stage? This action can not be reversed.")

                if (c) {
                    this.$socket.makePostRequest(approve)
                        .then((response) => {
                            if (response.type == 'ApproveStage2' && response.status == "true") {

                                this.$swal.fire("Success", "Applicant approved for next stage.")

                                setTimeout(() => {
                                    window.location.reload()
                                }, 1000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            },

            shareResume(id) {

                this.share_resume.applicant_ids[0] = this.$parent.applicant.id
                var data = this.share_resume
                console.log(data)
                let resume = {
                    what: "ForwardCV",
                    data: data
                }

                this.$socket.makePostRequest(resume)
                    .then((response) => {
                        if (response.type == "ForwardCV") {
                            this.$swal.fire("Success", "Resume Shared to Hiring Manager", 'success')

                            setTimeout(window.reload(), 2000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            listhiringmanager: function () {
                var hiringmanagers = {
                    what: 'listhiringmanager'
                }

                this.$socket.makeGetRequest(hiringmanagers)
                    .then((response) => {
                        this.hiringmanagers = response.data
                        console.log(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
        }
    }	
</script>